import { Tab, Tabs } from '@mui/material';
import React, { useState, useEffect, useCallback } from 'react';
import urlHelper from '../Helpers/urlHelper';
import FaIcon from './FaIcon';
import RoleService from '../Services/roleService';
import { iconsEnabled } from '../Helpers/iconHelper';

const TabbedPage = ({
  tabs = [],
  className = 'border rounded opacity70',
  removeSearchParametersOnTabChange = false,
  openOnTab = 0,
  onTabChange,
  refreshTabOnChange = true,
}) => {
  const [selectedTab, setSelectedTab] = useState(openOnTab);

  useEffect(() => {
    setSelectedTab(openOnTab);
  }, [openOnTab]);

  const getValidSelectedTab = useCallback((tabs, selectedTab) => (tabs?.[selectedTab] ? selectedTab : 0), []);

  const handleTabChange = (event, newValue) => {
    if (removeSearchParametersOnTabChange) {
      urlHelper.removeSearchParamsFromUrl();
    }
    setSelectedTab(newValue);
    if (onTabChange) {
      onTabChange(newValue);
    }
  };

  const renderTabLabels = () => {
    const tabLabels = [];

    tabs.forEach((tab, index) => {
      if (!tab) return;
      let hasPermission = false;
      if (tab.roleKey != null) {
        hasPermission =
          tab.roleKey === '' || RoleService.CheckUserPermission('tabbedPageTab', tab.roleKey ? tab.roleKey : '');
      } else if (tab.roleKey == null || tab.roleKey === '') {
        hasPermission = true;
      }
      if (hasPermission) {
        tabLabels.push(
          <Tab
            value={index}
            label={
              <span>
                {tab.icon && iconsEnabled() && <FaIcon iconName={tab.icon} />} {tab.label}
              </span>
            }
            key={`tabkey${index}`}
          />
        );
      }
    });
    return tabLabels;
  };

  const renderTabs = () => {
    if (tabs.length === 1) {
      return null;
    }
    const validTab = getValidSelectedTab(tabs, selectedTab);
    return (
      <Tabs
        value={validTab}
        onChange={handleTabChange}
        indicatorColor='primary'
        textColor='primary'
        variant='scrollable'
        scrollButtons='auto'
        allowScrollButtonsMobile
      >
        {renderTabLabels()}
      </Tabs>
    );
  };

  const validTab = getValidSelectedTab(tabs, selectedTab);
  const tab = tabs?.[validTab];

  if (!tab) {
    return null;
  }

  return (
    <div className={className}>
      <div className='bravo-ds'>{renderTabs()}</div>
      {tab?.component && (refreshTabOnChange ? <div key={validTab}>{tab.component}</div> : tab.component)}
    </div>
  );
};

export default TabbedPage;
